import IconTile from '../../Icon/IconTile';

const Ship = () => <IconTile name="vessel" />;

export { Ship };
